import { PartThumbnail as SharedPartThumbnail } from '../../components/PartThumbnail'

/**
 * A cart line's 40x40 thumbnail (screens.md Cart redesign — line table
 * "PART" column). UID-411: `url` is the REAL, Library-resolved thumbnail
 * (`CartViewWithLineSpecifications.lineThumbnails`, joined by sourceable id
 * at the call site) — rendered as a real `<img>` when present, falling back
 * to the placeholder box below on a miss or load failure (never a CSS
 * `background-image`, ADR-0126 D17). The unrelated
 * `CartLinePresentation.thumbnailRef` field (still just a demo asset-path
 * string, never a binary) stays unused here — this reads the sidecar array.
 *
 * Decorative only: the part's identity is already conveyed as text
 * (part id + material/spec line) right next to this box, so the icon is
 * `aria-hidden` rather than duplicating that text into an `alt`.
 *
 * UID-282: the custom-part revision label is NOT rendered here — the comp
 * (`.dc.html:2221`) places it below and OUTSIDE this box, so it is a sibling
 * (`.part-rev-caption`) under `.cart-part-thumb-wrap` at the call site. That
 * keeps this box decorative and its square area intact.
 */
export function PartThumbnail({ url }: { readonly url?: string | undefined }) {
  return (
    <SharedPartThumbnail
      url={url}
      imgClassName="cart-part-thumbnail-img"
      placeholder={<CartThumbnailPlaceholder />}
    />
  )
}

function CartThumbnailPlaceholder() {
  return (
    <span className="cart-part-thumbnail" aria-hidden="true">
      {/* Isometric 3D box glyph (Lucide "box") — parts are 3D CAD parts, so a
          cube reads as a "part image" placeholder better than a flat photo icon.
          Matches the orders-list / shipment / customs placeholder tiles. */}
      <svg
        aria-hidden="true"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z" />
        <path d="m3.3 7 8.7 5 8.7-5" />
        <path d="M12 22V12" />
      </svg>
    </span>
  )
}
